/* eslint-disable import/no-cycle */
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import SearchService from 'services/api/search.service';
import { ICommonCallbackPayload } from 'types/common';

import { StandardAction } from '../types';
import SearchAction from './search.actions';
import { SearchScopeEnum } from './types';
// import SearchSelectors from './search.selectors';

const { FETCH_SEARCH_SUGGESTION } = SearchAction.TYPES;

// placeholder for update search saga
function* fetchSearchSuggestion(
  action: StandardAction<{ searchInput: string; entities?: SearchScopeEnum[]; callback?: ICommonCallbackPayload }>,
) {
  const { payload } = action;
  if (payload) {
    try {
      // const { transactionSearch } = yield select(SearchSelectors.selectSearch);

      const result =
        payload.searchInput?.length > 0
          ? yield call(SearchService.fetchSearch, payload.searchInput, payload.entities)
          : {};
      yield put(SearchAction.fetchSearchSuggestionSuccess(result?.data || [], payload.searchInput));
      payload.callback?.callbackOnSuccess?.();
    } catch (error) {
      // notification.error({
      //   message: error,
      // });
      payload.callback?.callbackOnFailure?.(error.message);
      yield put(SearchAction.fetchSearchSuggestionError(error));
    }
  }
}

function* watchFetchSearchSuggestion() {
  yield takeEvery(FETCH_SEARCH_SUGGESTION.START, fetchSearchSuggestion);
}

export default function* rootSaga(): Generator {
  yield all([fork(watchFetchSearchSuggestion)]);
}
